/* Czech translation for the jQuery Timepicker Addon */ var jQuery = require('jquery');require('../timepicker');
/* Written by Ondřej Vodáček */
(function($) {
	$.timepicker.regional['cs'] = {
		timeOnlyTitle: 'Vyberte čas',
		timeText: 'Čas',
		hourText: 'Hodiny',
		minuteText: 'Minuty',
		secondText: 'Vteřiny',
		millisecText: 'Milisekundy',
		microsecText: 'Mikrosekundy',
		timezoneText: 'Časové pásmo',
		currentText: 'Nyní',
		closeText: 'Zavřít',
		timeFormat: 'HH:mm',
		timeSuffix: '',
		amNames: ['dop.', 'AM', 'A'],
		pmNames: ['odp.', 'PM', 'P'],
		isRTL: false
	};
	$.timepicker.setDefaults($.timepicker.regional['cs']);
})(jQuery);



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/third/jquery-ui/datetimePicker/i18n/jquery-ui-timepicker-cs.js